import {forwardRef} from "react";
import * as React from "react";
import * as _ from "lodash";
import { DateInput, DateInputProps } from './date-input';

interface Props extends DateInputProps {
  formik: any,
  name: string,
  required?: boolean,
  'data-test'?: string,
}

export const FormikDateInput = forwardRef((props: Props, ref: any) => {
  const {formik, name, required, ...rest} = props;

  return <DateInput
    fullWidth
    selectAllOnFocus
    error={formik.touched[name] && Boolean(formik.errors[name])}
    helperText={formik.touched[name] && formik.errors[name]}
    value={formik.values[name]}
    onChange={formik.handleChange}
    name={name}
    label={rest.label || `${_.startCase(name)}${required ? ' *' : ''}`}
    data-test={props['data-test'] || _.snakeCase(name)}
    placeholder={rest.placeholder || 'MM / DD / YYYY'}
    id={name}
    ref={ref}
    {...rest}
  />
})
